import { SummonerSpellCaster } from '../application/summonerSpellCaster.js';
import { createSummonerSpellInputWire } from './controllers/summonerSpellInputWire.js';
import { createSummonerSpellVfx } from './vfx/summonerSpellVfx.js';

/**
 * bootSummonerSpells — Live D/F caster + HUD + cast VFX + debug hooks.
 */
export function bootSummonerSpells({
  getCaster,
  getCursor,
  getAllies,
  inputController,
  hudUI,
  THREE,
  scene
} = {}) {
  const summonerSpellCaster = new SummonerSpellCaster();
  const spellVfx = createSummonerSpellVfx({ THREE, scene });
  const summonerSpellWire = createSummonerSpellInputWire({
    summonerSpellCaster,
    getCaster,
    getCursor,
    getAllies,
    onCastVisual: (spellId, ctx) => spellVfx.play(spellId, ctx)
  });
  wireCastHandlers(inputController, summonerSpellWire, () => syncHud());
  wireDebugHooks(summonerSpellCaster, summonerSpellWire, () => syncHud());

  function syncHud() {
    if (hudUI && typeof hudUI.updateSummonerHUD === 'function') {
      hudUI.updateSummonerHUD(summonerSpellCaster.getHudSnapshot());
    }
  }

  function applyLobbySpells(matchConfig) {
    if (!matchConfig) return;
    if (matchConfig.mapId) summonerSpellCaster.setMapId(matchConfig.mapId);
    if (!Array.isArray(matchConfig.spells) || matchConfig.spells.length < 2) return;
    summonerSpellCaster.setSpells(matchConfig.spells[0], matchConfig.spells[1]);
    syncHud();
  }

  function tick(dt, caster) {
    summonerSpellCaster.tick(dt, caster);
    spellVfx.tick(dt);
    syncHud();
  }

  syncHud();
  return { summonerSpellCaster, summonerSpellWire, applyLobbySpells, tick, spellVfx };
}

function wireCastHandlers(inputController, wire, syncHud) {
  if (!inputController) return;
  inputController.onCastD = () => {
    const result = wire.onCastD();
    syncHud();
    return result;
  };
  inputController.onCastF = () => {
    const result = wire.onCastF();
    syncHud();
    return result;
  };
}

function wireDebugHooks(caster, wire, syncHud) {
  if (typeof window === 'undefined') return;
  window.__debugCastSummoner = (slot) => {
    const key = String(slot || '').toUpperCase();
    const result = key === 'F' ? wire.onCastF() : wire.onCastD();
    syncHud();
    return result;
  };
  window.__debugGetSummonerSpells = () => ({
    D: caster.spellD,
    F: caster.spellF,
    cooldownD: caster.cooldownD,
    cooldownF: caster.cooldownF
  });
}
